module.exports = __webpack_public_path__ + "static/img/1.c5280e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/1.png
// module id = F54H
// module chunks = 0